import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/DataList/";

export function getHearAbout() {
  return apiUtils
    .get(
      `${baseUrl}hearabout`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getRegions(regionId = "") {
  return apiUtils
    .get(
      `${baseUrl}GetRegions?regionId=${encodeURIComponent(regionId ?? "")}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getRegionId({ regionTypeId, description }) {
  return apiUtils
    .get(
      `${baseUrl}GetRegionId?regionTypeId=${encodeURIComponent(regionTypeId)}` +
        `&description=${encodeURIComponent(description)}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
